/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Flow_Item_LabelInputs */

const en_task_flow_item_label = /** @type {(inputs: Task_Flow_Item_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const pt_br2_task_flow_item_label = /** @type {(inputs: Task_Flow_Item_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

/**
* | output |
* | --- |
* | "Item" |
*
* @param {Task_Flow_Item_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_flow_item_label = /** @type {((inputs?: Task_Flow_Item_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Flow_Item_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_flow_item_label(inputs)
	return pt_br2_task_flow_item_label(inputs)
});